import React, { useState } from "react"

import { useAppDispatch } from "redux/hooks"
import { makeSignPaymentSchedule } from "redux/features/payment_schedule/paymentScheduleSignThunk"
import Spinner from "components/ui/Spinner"
import IdCard from "components/Sign/IdCard"
import { ClientIdCardSignResponseValues } from "types"
import { ID_CARD_SIGN_METHOD } from "config"

type Props = {
  paymentScheduleId: string
  onFailure: () => void
  onSuccess: () => void
}

const IdCardSignComponent = ({
  paymentScheduleId,
  onFailure,
  onSuccess,
}: Props) => {
  const dispatch = useAppDispatch()

  const signObject = {
    type: "PaymentSchedule",
    id: paymentScheduleId,
  }

  const [isSubmitting, setSubmitting] = useState(false)

  const handleSubmit = (values: ClientIdCardSignResponseValues) => {
    setSubmitting(true)

    const { signature, certificate } = values

    const params = {
      payment_schedule_id: paymentScheduleId,
      signing_method: ID_CARD_SIGN_METHOD,
      signature,
      certificate,
    }

    dispatch(makeSignPaymentSchedule(params))
      .then(() => {
        onSuccess()
      })
      .catch(() => {
        onFailure()
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  return (
    <>
      <Spinner open={isSubmitting} />
      <IdCard signObject={signObject} onSubmit={handleSubmit} />
    </>
  )
}

export default IdCardSignComponent
